import {needAuth} from "../instance/Instance";

async function getEvaluationReportList(search, pageable) {
    console.log(">> 종합보고서 목록 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    const searchDto = {};
    for (const key in search) {
        if (search.hasOwnProperty(key)) {
            if (typeof search[key] === 'object' && search[key] !== null) {
                searchDto[key] = search[key].id;
            } else {
                searchDto[key] = search[key];
            }
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post('/evaluation/report?'+pageStr,searchDto);
    }catch (error){
        if (error?.response?.data) {
            return error.response;
        }
        return error;
    }
}

async function getEvaluationReportChildrenList(search, pageable) {
    console.log(">> SLA목록 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post('/evaluation/report/children?'+pageStr,search);
    }catch (error){
        return error;
    }
}

async function saveEvaluationReport(data) {
    return await needAuth.post(`/evaluation/report/create`, data);
}

async function getEvaluationReport(id, type){
    return await needAuth.get(`/evaluation/report/${id}/${type}`);
}

async function getChartDataBySearch(search){
    return await needAuth.post(`/evaluation/report/chart`, search);
}

async function removeEvaluationReport(ids) {
    return await needAuth.put('/evaluation/report/delete', ids);
}

export {
    getEvaluationReportList,
    saveEvaluationReport,
    getEvaluationReport,
    removeEvaluationReport,
    getEvaluationReportChildrenList,
    getChartDataBySearch
}